import { forwardRef, Children } from 'react';
import { Panel } from '@uds/panel';
import { LabelOption, Label } from '@uds/label';
import { classNames } from '@uds/typography';
import { cx } from 'linaria';
import './switch.stylesheet_1ibzs41.css';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import './multiswitch.stylesheet_ifqcae.css';

const root$1 = {
  default: "d1spy0lq",
  readOnly: "rfh4en7",
  disabled: "d17omkph",
  checkboxOnly: "c1j3a75t"
};
const inner = "iw00nyt";

// from ux theme utils, srOnly
// to get this to a package and import from there
// in the future
const input = "iedz5lr";
const switchOuter = {
  default: "dl423dq",
  disabled: "d8gtn4d",
  on: "o1r5tb51"
};
const switchKnob = {
  default: "d1n0pb06",
  on: "o1qe780p"
};
const labelCss = {
  default: "d1tag0bl",
  disabled: "d1koy75p"
};
const getClassNames$1 = _ref => {
  let {
    readOnly,
    disabled,
    multi,
    hasLabel,
    on
  } = _ref;
  const checkboxOnly = !multi && !hasLabel;
  return {
    root: cx(root$1.default, readOnly && root$1.readOnly, disabled && root$1.disabled, checkboxOnly && root$1.checkboxOnly),
    inner,
    input,
    label: cx(labelCss.default, classNames.headingXxs, disabled && labelCss.disabled),
    switch: cx(switchOuter.default, disabled && switchOuter.disabled, on && switchOuter.on),
    switchKnob: cx(switchKnob.default, on && switchKnob.on)
  };
};

const Switch = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    id,
    multi,
    label,
    hint,
    on,
    onClick,
    ...inputProps
  } = _ref;
  const {
    readOnly,
    disabled
  } = inputProps;
  const hasLabel = label != null;
  const classNames = getClassNames$1({
    readOnly,
    disabled,
    multi,
    hasLabel,
    on
  });
  const handleClick = e => {
    e.stopPropagation();
    if (onClick) {
      onClick(e);
    }
  };
  return /*#__PURE__*/jsx(Panel, {
    border: false,
    children: /*#__PURE__*/jsx(LabelOption, {
      htmlFor: id,
      className: classNames.root,
      hint: hint,
      children: /*#__PURE__*/jsxs("div", {
        className: classNames.inner,
        children: [/*#__PURE__*/jsx("input", {
          id: id,
          className: classNames.input,
          type: "checkbox",
          ...inputProps,
          ref: ref,
          onClick: handleClick
        }), hasLabel && /*#__PURE__*/jsx("span", {
          className: classNames.label,
          children: label
        }), /*#__PURE__*/jsx("span", {
          className: classNames.switch,
          children: /*#__PURE__*/jsx("span", {
            className: classNames.switchKnob
          })
        })]
      })
    })
  });
});
Switch.displayName = 'Switch';
var Switch$1 = Switch;

const root = "r1nvi8c9";
const panel = {
  default: "d1smp7ij",
  error: "e1te1eqj"
};
const divider = "dbctfg9";
const getClassNames = _ref => {
  let {
    hasError
  } = _ref;
  return {
    root,
    panel: cx(panel.default, hasError && panel.error),
    divider
  };
};

const MultiSwitch = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    label,
    disabled,
    hasError,
    id
  } = _ref;
  const classNames = getClassNames({
    hasError
  });
  return /*#__PURE__*/jsxs("fieldset", {
    className: classNames.root,
    id: id,
    children: [label != null && /*#__PURE__*/jsx(Label, {
      as: "legend",
      children: label
    }), /*#__PURE__*/jsx(Panel, {
      className: classNames.panel,
      children: Children.map(children, (option, i) => /*#__PURE__*/jsxs(Fragment, {
        children: [i !== 0 && /*#__PURE__*/jsx("span", {
          className: classNames.divider
        }), /*#__PURE__*/jsx(option.type, {
          ...option.props,
          multi: true,
          disabled: disabled,
          ref: ref
        })]
      }))
    })]
  });
});
MultiSwitch.displayName = 'MultiSwitch';
var MultiSwitch$1 = MultiSwitch;

export { MultiSwitch$1 as MultiSwitch, Switch$1 as Switch };
